var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramFlight40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "41px",
    viewBox: "0 0 40 41",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pictos",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Flight64*-Copy",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("g", {
    id: "Passport",
    transform: "translate(19.794604, 19.011939) rotate(45.000000) translate(-19.794604, -19.011939) translate(6.794604, 6.011939)",
    fillRule: "nonzero",
    stroke: "#4F4C4D",
    strokeWidth: 1.00250627
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.990348, 0.492767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2597271,0.00719992218 C12.788647,0.00870939578 13.2543152,0.210757759 13.5885468,0.544527644 C13.9236429,0.879160739 14.1245896,1.3447988 14.1245896,1.86054931 L14.1245896,1.86054931 L14.1241376,21.978582 L17.2372378,23.1134123 L17.2372378,24.9238666 L12.348638,24.0749773 L7.45462915,24.9238666 L7.45462915,23.1134256 L10.5668253,21.9790636 L10.5672774,1.86056014 C10.5672774,1.36296882 10.755587,0.911137396 11.0615703,0.577921831 C11.3670076,0.245300848 11.7897176,0.0306252795 12.2597271,0.00719992218 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Wing",
    fill: "#FFCC00",
    points: "14.3719781 7.90783424 24.1545868 12.4600934 24.1545868 15.4911676 14.3719781 13.215038"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Wing",
    fill: "#FFCC00",
    transform: "translate(5.428585, 11.699501) scale(-1, 1) translate(-5.428585, -11.699501) ",
    points: "0.537280207 7.90783424 10.3198889 12.4600934 10.3198889 15.4911676 0.537280207 13.215038"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramFlight40);
export default __webpack_public_path__ + "static/media/pictogramFlight40.0ae4857f2361df0e29de462a9936c63d.svg";
export { ForwardRef as ReactComponent };